export const eventOptions = [
  {
    value: '$pageview',
    label: 'Web页面浏览'
  },
  {
    value: '$buttonclick',
    label: '按钮点击'
  }
];

export const metricOptions = [
  {
    value: 'count',
    label: '总次数'
  },
  {
    value: 'unique',
    label: '用户数'
  },
  {
    value: 'visitor',
    label: '访客数'
  }
];

export const fieldOptions = [
  {
    value: 'distinct_id',
    label: 'DistinctID'
  },
  {
    value: 'title',
    label: '页面标题'
  },
  {
    value: 'url',
    label: '页面URL'
  },
  {
    value: 'event_session_id',
    label: '用户ID'
  },
  {
    value: 'element_name',
    label: '元素名称'
  },
  {
    value: 'element_content',
    label: '元素标签'
  }
];

export const operatorOptions = [
  {
    value: 'equals',
    label: '等于'
  },
  {
    value: 'notEquals',
    label: '不等于'
  },
  {
    value: 'contains',
    label: '包含'
  },
  {
    value: 'notContains',
    label: '不包含'
  },
  {
    value: 'isEmpty',
    label: '为空'
  },
  {
    value: 'isNotEmpty',
    label: '不为空'
  }
];

export const groupByOptions = [
  {
    value: 'distinct_id',
    label: 'DistinctID'
  },
  {
    value: 'title',
    label: '页面标题'
  },
  {
    value: 'url',
    label: '页面URL'
  },
  {
    value: 'event_session_id',
    label: '用户ID'
  },
  {
    value: 'element_name',
    label: '元素名称'
  },
  {
    value: 'element_content',
    label: '元素标签'
  }
];

export const timeUnitOptions = [
  {
    value: 'hour',
    label: '按小时'
  },
  {
    value: 'day',
    label: '按天'
  },
  {
    value: 'week',
    label: '按周'
  },
  {
    value: 'month',
    label: '按月'
  }
];

export const projectOptions = [
  {
    value: 'devops',
    label: '智云'
  },
  {
    value: 'taishan',
    label: '泰山'
  },
  {
    value: 'nvwa',
    label: '女娲'
  },
  {
    value: 'bbs',
    label: '小狐论坛'
  },
  {
    value: 'devops-qa',
    label: '智云-测试'
  },
  {
    value: 'taishan-qa',
    label: '泰山-测试'
  },
  {
    value: 'nvwa-qa',
    label: '女娲-测试'
  },
  {
    value: 'bbs-qa',
    label: '小狐论坛-测试'
  }
];

export const defaultValues = {
  selectedEvent: '$buttonclick',
  selectedMetric: 'count',
  byFields: ['element_name'],
  timeUnit: 'hour',
  defaultCondition: {
    field: 'element_name',
    function: 'contains',
    params: ''
  }
};
